/**
 * @author Rahul Nainala
 * @description Helper Function for Support team, to know the 3D Space points each equidistant from one another with 5cms.
 */
import React from 'react';
import * as THREE from 'three';
import { useThree } from '@react-three/fiber';

const Points = () => {
  let { scene } = useThree();

  React.useEffect(() => {
    let dotGeometry = new THREE.SphereGeometry(0.1, 32, 32);
    let dotMaterial = new THREE.MeshBasicMaterial({ color: 0xffff00 });

    for (let x = -120; x <= 20; x += 5) {
      for (let y = -10; y <= 10; y += 5) {
        for (let z = -10; z <= 10; z += 5) {
          let dot = new THREE.Mesh(dotGeometry, dotMaterial);
          dot.position.set(x, y, z);
          dot.userData.isDot = true;
          scene.add(dot);
        }
      }
    }

    return () => {
      scene.traverse((object) => {
        if (object.isMesh && object.userData && object.userData.isDot) {
          scene.remove(object);
        }
      });
    };
  }, [scene]);

  return null;
};

export default Points;
